export const theme = {
  borderPrimary: "1px solid lightblue",
  borderRadius: 1,
  commonPadding: 2,
  gap: 2,
};
